import type { NodePropertySchema } from '../../../types/node-properties';

const schema: NodePropertySchema = {
  nodeType: 'github',
  version: '1.5.0',
  properties: [
    // Properties will be defined based on n8n equivalents
  ]
};

export default schema;
